import { Toolbar } from 'components/Toolbar';
import { TooltipWrapper } from 'components/TooltipWrapper';
import type { ConstructionTypeData } from 'gql/graphql';
import type { IUseAccess } from 'hooks/useAccess';
import { Button, cnMixSpace, IconQuestion } from 'uikit';
import { formatDateToLocale } from 'utils';

import Styles from '../catalogBaseCost.module.css';

import { CatalogUerBaseCostExport } from './CatalogUerBaseCostExport';
import { CatalogUerBaseCostMassUpload } from './CatalogUerBaseCostMassUpload';

interface ICatalogPriceToolbar {
    onSuccessAction: () => void;
    handleOpenModalEstimate: () => void;
    handleOpenHistory: () => void;
    handleOpenMassRatioApplicationModal: () => void;
    updatedAt: Date;
    catalogUERConstructionTypesItems?: ConstructionTypeData[] | null;
    catalogPriceRules: IUseAccess['catalogPrice'];
    catalogId: number;
}

export const CatalogPriceToolbar = ({
    catalogId,
    onSuccessAction,
    handleOpenModalEstimate,
    handleOpenHistory,
    handleOpenMassRatioApplicationModal,
    updatedAt,
    catalogUERConstructionTypesItems,
    catalogPriceRules,
}: ICatalogPriceToolbar) => (
    <Toolbar>
        <div className={Styles.ContentToolbar}>
            <div className={Styles.flexCenter}>
                <Button
                    disabled={!catalogPriceRules.canCreate}
                    label="Создать расценку"
                    onClick={() => {
                        handleOpenModalEstimate();
                    }}
                    size="s"
                    view="secondary"
                />
                <CatalogUerBaseCostMassUpload
                    catalogId={catalogId}
                    onSuccessAction={onSuccessAction}
                    disabled={!catalogPriceRules.canCreate}
                />
                <Button
                    label="Просмотреть историю изменений"
                    onClick={handleOpenHistory}
                    size="s"
                    className={cnMixSpace({ mL: 's' })}
                    view="secondary"
                />
                <CatalogUerBaseCostExport disabled={!catalogPriceRules.canExport} />
                <Button
                    label="Массовое применение коэффициентов"
                    onClick={handleOpenMassRatioApplicationModal}
                    size="s"
                    className={cnMixSpace({ mL: 's' })}
                    view="secondary"
                    disabled={!catalogPriceRules.canEdit}
                />
            </div>
            <div className={Styles.WrapperTooltip}>
                <TooltipWrapper
                    direction="downCenter"
                    isHidden={!catalogUERConstructionTypesItems?.length}
                    message={catalogUERConstructionTypesItems?.map((i, index) => (
                        <div className={Styles.ItemTooltip} key={index}>
                            {i.name}
                        </div>
                    ))}
                >
                    <IconQuestion size="s" />
                </TooltipWrapper>
                <div className={Styles.titleInfoText}>
                    <span>Видов строительства: {catalogUERConstructionTypesItems?.length}</span>
                    <span className={Styles.Delimiter}>|</span>
                    <span>Обновлён: {formatDateToLocale(updatedAt, true)}</span>
                </div>
            </div>
        </div>
    </Toolbar>
);

CatalogPriceToolbar.displayName = 'CatalogPriceToolbar';
